
const Modal = ({ handleClose, show, children, props }) => {
    const showHideClassName = show ? "modal block" : "modal hidden";
    return(
        <div className={showHideClassName}>
            
            <div className="modal-main-desktop rounded-xl">
            
                <button type="button" onClick={handleClose} className=" cursor-pointer right-5 absolute ">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
                {children}
                
                </div>
        </div>
       
    )
}

export default Modal;